"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMeristemExperimentStateVisitData = exports.getRouteId = exports.getLanguage = exports.getSubdivision = exports.getCountryCode = exports.isUserExternal = exports.isUserABot = exports.getMeristemContext = exports.getRequestMetadata = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const url_1 = require("./url");
const meristem_context_1 = require("@noom/meristem-context");
function getRequestMetadata() {
    return window.meristemContext;
}
exports.getRequestMetadata = getRequestMetadata;
function getMeristemContext() {
    const globalMeristemContext = getRequestMetadata();
    if (!globalMeristemContext) {
        // We want to trigger an error if the meristem context defaults for the production environment.
        throw new Error("MeristemContextDefaulted-UnavailableOnWindow");
    }
    return globalMeristemContext.context;
}
exports.getMeristemContext = getMeristemContext;
function isUserABot() {
    var _a, _b;
    return (!((_a = getRequestMetadata()) === null || _a === void 0 ? void 0 : _a.meristemTrackingProperties) ||
        ((_b = getRequestMetadata()) === null || _b === void 0 ? void 0 : _b.meristemTrackingProperties.userIsBot) ||
        // Not necessarily bots, but exclude old unsupported browsers from
        // tracking.
        !Object.fromEntries ||
        typeof ResizeObserver === "undefined");
}
exports.isUserABot = isUserABot;
function isUserExternal(externalUrlParamKey) {
    return url_1.isReferrerFromNoom() && js_cookie_1.default.get(externalUrlParamKey);
}
exports.isUserExternal = isUserExternal;
/**
 * Returns user's two character country code (e.g. "US", "GB")
 */
function getCountryCode() {
    const { country_code } = getMeristemContext();
    return country_code;
}
exports.getCountryCode = getCountryCode;
function getSubdivision() {
    const { subdivision } = getMeristemContext();
    return subdivision;
}
exports.getSubdivision = getSubdivision;
function getLanguage() {
    const { language_code } = getMeristemContext();
    return language_code || "en";
}
exports.getLanguage = getLanguage;
function getRouteId() {
    var _a;
    return (((_a = getMeristemContext()) === null || _a === void 0 ? void 0 : _a.route_id) ||
        meristem_context_1.ROUTE_CONSTANTS.direct);
}
exports.getRouteId = getRouteId;
function formatMeristemExperimentStateVisitData() {
    const experimentProps = Object.entries(getRequestMetadata().meristemTrackingProperties).reduce((acc, [key, value]) => {
        if (key.startsWith("Meristem ") || key.endsWith(" SHA")) {
            acc[key] = value;
        }
        return acc;
    }, {});
    if (Object.keys(experimentProps).length) {
        return { meristem_experiment: experimentProps };
    }
    return {};
}
exports.formatMeristemExperimentStateVisitData = formatMeristemExperimentStateVisitData;
//# sourceMappingURL=context.js.map